import { helpers } from "vuelidate/lib/validators";
import { CustomerDiscounts } from "../models/customer";
/**
 * Custom validators for use with Vuelidate library
 * @const phone regex checks if valid phone number, ignores formatting
 */

export const phone = helpers.regex(
  "phone",
  /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/
);

export const salesYear = (value) => value && value !== 0;
export const salesAmt = (value) => value && value != "$0.00";
export const discountAmt = (value) => value && value != "%0.00";
export const discountHandle = (value) =>
  value && Object.values(CustomerDiscounts).includes(value);
